// extracted by mini-css-extract-plugin
export default {"dialogLoadingSpinnerContainer":"ConfirmModal-module_dialogLoadingSpinnerContainer__P5fAEL","spinner":"ConfirmModal-module_spinner__zNdNEN"};